
















import {
  SimilarityAnalysisItem,
  SimilarityAnalysisResult,
} from '@/interfaces/types/AnalysisResult';
import { countFileFrequency } from '@/utils/similarityUtils';
import Vue from 'vue';
import GNB from '../components/common/GNB/GNB.vue';
import Spinner from '../components/common/Spinner/Spinner.vue';
import SimilarityDescription from '../components/SimilarityAnalysisView/SimilarityDescription.vue';
import SimilarityDetailedInformation from '../components/SimilarityAnalysisView/SimilarityDetailedInformation.vue';

export default Vue.extend({
  components: {
    GNB,
    SimilarityDescription,
    SimilarityDetailedInformation,
    Spinner,
  },
  data(): {
    selectedAnalysisItem?: SimilarityAnalysisItem;
    similarityAnalysisResult: SimilarityAnalysisResult;
  } {
    return {
      selectedAnalysisItem: undefined,
      similarityAnalysisResult: countFileFrequency(
        this.$store.getters.similarityAnalysis,
      ),
    };
  },
  methods: {
    changeSelectedItem(selectedIndex: number) {
      this.selectedAnalysisItem =
        this.similarityAnalysisResult.analysis_list[selectedIndex];
    },
  },
});
